<template>
  <div class="control is-expanded" :class="[size]">
    <d-dropdown ref="dropdown" :position="position" :disabled="disabled" trap-focus class="py-0">
        <div slot="activator">
          <d-input
            ref="input"
            autocomplete="off"
            v-model="computedValue"
            :placeholder="placeholder"
            :size="size"
            :rounded="rounded"
            :loading="loading"
            :disabled="disabled"
            :readonly="!editable"
            v-bind="$attrs"
            @change.native="$emit('change', $event)"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
          />
        </div>
        <d-dropdown-item :disabled="disabled" custom paddingless class="p-0">
          <chrome-picker v-model="computedColorValue" />
        </d-dropdown-item>
    </d-dropdown>
  </div>
</template>

<script>
import FormElementMixin from '../../../utils/mixins/formElementMixin.js';
import DInput from '../DInput/DInput.vue';
import { Chrome } from 'vue-color'

export default {
  components: {
    'chrome-picker': Chrome,
    DInput
  },

  mixins: [FormElementMixin],

  props: {
    value: String,
    disabled: Boolean,
    editable: {
      type: Boolean,
      default: true
    },
    placeholder: String,
    position: {
      type: String,
      default: 'left',
    },
  },

  data() {
    return {
      newValue: this.value
    }
  },

  computed: {
    computedValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.newValue = value
          this.$emit('input', value);
        },
      },

    computedColorValue: {
        get() {
          return this.value || '#000000';
        },
        set(value) {
          const parsedValue = value.hex || ""
          this.newValue = parsedValue;
          this.$emit('input', parsedValue);
        },
      },
  }
}
</script>